import Vue from 'vue';
import Vuex from 'vuex';
import smsModule from './smsModule/'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    underageList: [],
    underageVaccines: [],
    listUnderagesAndVaccines: [],
    financer: 0,
    person: {},
    prebono: {},
    appointment: {},
    membershipRequest: {},
    showFilterModal: false,
    membershipRequestComplete: false,
  },
  mutations: {
    saveUnderageList(state, payload) {
      state.underageList = payload;
    },
    saveUnderageVaccines(state, payload) {
      state.underageVaccines = payload;
    },
    saveListUnderagesAndVaccines(state, payload) {
      state.listUnderagesAndVaccines = payload;
    },
    saveFinancer(state, payload) {
      state.financer = payload;
    },
    savePerson(state, payload) {
      state.person = payload;
    },
    savePrebono(state, payload) {
      state.prebono = payload;
    },
    saveAppointment(state, payload) {
      state.appointment = payload;
    },
    saveMembershipRequest(state, payload) {
      state.membershipRequest = payload;
    },
    saveShowFilterModal(state, payload) {
      state.showFilterModal = payload;
    },
    savemembershipsRequestComplete(state, payload) {
      state.membershipRequestComplete = payload;
    }
  },
  actions: {
    fetchUnderageList: async function (state) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/consult/underAge`)
          .then((res) => {
            state.commit('saveUnderageList', res.data.data);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    deleteChild: async function (state, payload) {
      const body = { id_register: payload };
      return new Promise((resolve, reject) => {
        axios
          .post('/api/delete/underAge', body)
          .then((res) => {
            const updatedData = state.state.underageList.filter((child) => child.id !== payload);
            state.commit('saveUnderageList', updatedData);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    editChild: async function (state, payload) {
      return new Promise((resolve, reject) => {
        axios
          .patch('/api/edit/underAge', payload)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  getters: {
    getUnderageList: (state) => state.underageList,
    getUnderageVaccines: (state) => state.underageVaccines,
    getFinancer: (state) => state.financer,
    getPerson: (state) => state.person,
    getPrebono: (state) => state.prebono,
    getAppointment: (state) => state.appointment,
    getMembershipRequest: (state) => state.membershipRequest,
    getShowFilterModal: (state) => state.showFilterModal,
    getMembershipRequestComplete: (state) => state.membershipRequestComplete,
  },
  modules: {
    smsModule
  },
});
